var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFsb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.611 1.44C10.115 3.977 3.408 9.76 1.424 19.067c-.423 1.984-.577 3.895-.483 5.726.205 2.775.966 5.6 2.382 8.362 6 11.703 21.368 15.447 31.23 7.306 4.878-4.027 6.974-10.085 6.168-15.668-.88-5.957-4.884-11.122-10.965-12.522-7.95-1.83-15.345 4.14-14.376 11.733.034.268.082.53.143.79.546 2.181 1.884 4.08 3.829 5.13 3.217 1.737 6.429.883 8.66-2.692-.566 2.68-2.36 4.215-4.732 4.703-4.043.834-7.984-2.207-9.233-6.602a9.944 9.944 0 01-.137-.54c-1.171-5.047 1.78-10.85 7.36-13.31 7.463-3.293 16.587.578 19.972 8.472.679 1.583.93 3.207 1.187 4.838 1.444 9.888-3.861 19.957-13.269 23.046-1.54.506-2.49.683-4.265.885 1.25.172 4.513-.243 5.626-.576 8.496-2.539 15.204-8.32 17.188-17.629.422-1.983.577-3.894.483-5.726-.205-2.775-.966-5.6-2.383-8.362C39.81 4.73 24.441.985 14.58 9.126c-4.877 4.027-7.15 10.085-6.344 15.668.88 5.957 5.06 11.122 11.141 12.522 7.951 1.83 15.186-4.14 14.217-11.733a7.864 7.864 0 00-.143-.789c-.546-2.182-1.724-4.08-3.669-5.13-3.217-1.737-6.43-.883-8.66 2.692.566-2.68 2.359-4.215 4.732-4.704 4.042-.833 7.81 2.207 9.058 6.603.052.179.097.359.138.54 1.17 5.047-1.607 10.849-7.186 13.31-7.463 3.292-16.587-.578-19.972-8.472a20.25 20.25 0 01-1.395-4.839C5.05 14.907 10.566 4.837 19.973 1.75c1.54-.506 2.49-.683 4.265-.886-.201-.027-.454-.04-.742-.04-1.502 0-3.95.337-4.885.616z",
    fill: "url(#paint0_linear_363_18170)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_363_18170",
    x1: 24.18,
    y1: 56.577,
    x2: 56.293,
    y2: 27.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C7D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F0A3"
  })))));
}
SvgIconFsb.displayName = 'IconFsb';
export default SvgIconFsb;